<template>
  <a-drawer
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :closable="true"
    :headerStyle="{paddingTop:'0px',background:'#F4F9FD'}"
    :bodyStyle="{background:'#F4F9FD',padding: 0 }"
    :drawerStyle="{background:'#F4F9FD'}"
    @close="close"
    cancelText="关闭">
    <div class="model-top">
      {{title}}
    </div>
    <dm-zj-work-order-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></dm-zj-work-order-form>
    <div class="drawer-footer">
      <a-button @click="close" style="margin-bottom: 0;">关闭</a-button>
      <a-button  @click="handleOk"   type="primary" style="margin-bottom: 0;">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>

  import DmZjWorkOrderForm from './DmZjWorkOrderForm'
  export default {
    name: 'DmZjWorkOrderModal',
    components: {
      DmZjWorkOrderForm
    },
    data () {
      return {
        title:'',
        width:400,
        visible: false,
        disableSubmit: false,
        cls:'top-bg0',
        titleMap:{
          0:"创建",
          1:"转交",
          2:"结束",
          3:"重启",
          4:"挂起",
          5:"交付",
          6:"验收"
        }
      }
    },
    methods: {
      add (record) {
        if(record.type!=undefined){
          this.cls = "top-bg"+record.type;
         record.ids= record.ids+""
          if(record.ids.split(",").length>1){
            this.title = "批量"+this.titleMap[record.type]
          }else{
            this.title = this.titleMap[record.type]+"工单"
          }

        }
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(record);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(workOrderId){
        this.$emit('ok',workOrderId);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
<style lang="less" scoped>

  .model-top{
    height: 48px;
    line-height: 48px;
    color: #0A1629;
    font-size: 16px;
    background:#F4F9FD;
    padding-left: 24px;
    border-bottom: 1px solid #E6EDF5;
  }

  .drawer-footer .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer{
    justify-content: center;
    display: flex;
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: center;
    left: 0;
    border-radius: 0 0 2px 2px;
  }
  /deep/ .ant-drawer-body{
    padding: 0 !important;
  }
  /deep/ .ant-modal-footer{
    text-align: center !important;
  }
  /deep/ .ant-select-disabled .ant-select-selection{
    background: #E6EDF5 !important;
  }
  /deep/ .ant-drawer-content::-webkit-scrollbar-thumb{
    background: #E6EDF5 !important; /* 滑块颜色（可选搭配） */
    border-radius: 4px!important;
  }

  /deep/ .ant-drawer-content::-webkit-scrollbar-thumb:hover {
    background: #E6EDF5 !important; /* 滑块颜色（可选搭配） */
  }
</style>